<mat-tab-group>
    <mat-tab label="Door Status">
        <app-authenticated-iframe-wrapper [src]="doorStatusUrl" height="6000px" width="100%">
        </app-authenticated-iframe-wrapper>
    </mat-tab>
    <mat-tab label="SIM Status">
        <app-authenticated-iframe-wrapper [src]="simStatusUrl" height="1500px" width="100%">
        </app-authenticated-iframe-wrapper>
    </mat-tab>
</mat-tab-group>